import { Application } from 'common/src/services';
import { IPlanPricingPageData } from '../interface/pageData';

class AppService extends Application<IPlanPricingPageData> {}
const templateData = Application.getTemplateData();
const data = templateData.data;
const config = templateData.config;
const pageData: IPlanPricingPageData = {
    Lang: config.lang,
    SYSTEM: config.system,
    siteHost: config.site_host,
    userInfo: data.user_info,
    contextInfo: data.context_info,
};

const appService = new AppService(pageData);
const getAppData = appService.getData;
export default appService;
export { getAppData };
